import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavbarService {
  PREZ_URL: string | undefined;
  private httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  url = (): Promise<object> => {
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'No-Auth': 'True',
    });
    const url$ = this.httpClient.get(`/api/v1/links/nav`, { headers: reqHeader }).pipe(
      tap(res => {
        // @ts-ignore
        this.PREZ_URL = res['data'].endsWith('/') ? res['data'].slice(0, -1) : res['data'];
      }),
      catchError(err => {
        throw new Error(err);
      }),
    );
    return firstValueFrom(url$);
  };
}
